import React from 'react';
import './MobileEmergencyBar.css';
import { phoneNumbers } from '../../data/phoneNumbers';
import { Phone, MessageCircle } from 'lucide-react';

const MobileEmergencyBar = () => {
  const primaryPhone = phoneNumbers[0] || '01055557235';
  const whatsappUrl = `https://wa.me/+2${primaryPhone}?text=${encodeURIComponent('مرحباً، أحتاج ونش انقاذ سيارات فوراً، أرجو إرسال أقرب ونش لموقعي.')}`;

  return (
    <div className="mobile-emergency-bar" role="region" aria-label="أزرار الطوارئ للاتصال والواتساب السريع">
      <div className="mobile-bar-container">
        <a
          href={`tel:${primaryPhone}`}
          className="mobile-bar-btn call-btn"
          aria-label={`اتصل بالونش الآن على الرقم ${primaryPhone}`}
        >
          <div className="btn-icon call-icon-pulse">
            <Phone size={20} />
          </div>
          <div className="btn-text">
            <span className="btn-title">اتصل بالونش الآن</span>
            <span className="btn-subtitle">{primaryPhone}</span>
          </div>
        </a>

        <a
          href={whatsappUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="mobile-bar-btn whatsapp-btn"
          aria-label="أرسل موقعك على واتساب لطلب ونش إنقاذ"
        >
          <div className="btn-icon">
            <MessageCircle size={20} />
          </div>
          <div className="btn-text">
            <span className="btn-title">أرسل موقعك واتساب</span>
            <span className="btn-subtitle">خصم 50% فوري</span>
          </div>
        </a>
      </div>
    </div>
  );
};

export default MobileEmergencyBar;
